const galleryStatus = {
  live: '102900000',
  alumni: '102900001',
  testing: '102900002',
  outOfBusiness: '102900003'
}

export default galleryStatus
